export const ClientColors = {
  williams: {
    primary: {
      main: "#32CD32",
    },
    barGraph: [
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
    ],
    fill: [
      '#EBFEF6',
      '#FFFAEC',
      '#F0F9FF',
      '#F1FCEF',
      '#FBF4F8',
      '#E9FFFB',
      '#FEFBE8',
      '#FFF3FE',
      '#F4F2FF',
      '#FFF1F3',
    ],
    stroke: [
      '#009E73',
      '#D55E00',
      '#0072B2',
      '#3FD03E',
      '#CC79A7',
      '#00EFEE',
      '#ECA906',
      '#F73EE7',
      '#4A18BF',
      '#FF2F4A',
    ],
  },
  HDC: {
    primary: {
      main: "#132342",
    },
    barGraph: [
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
    ],
    fill: [
      '#EBFEF6',
      '#FFFAEC',
      '#F0F9FF',
      '#F1FCEF',
      '#FBF4F8',
      '#E9FFFB',
      '#FEFBE8',
      '#FFF3FE',
      '#F4F2FF',
      '#FFF1F3',
    ],
    stroke: [
      '#009E73',
      '#D55E00',
      '#0072B2',
      '#3FD03E',
      '#CC79A7',
      '#00EFEE',
      '#ECA906',
      '#F73EE7',
      '#4A18BF',
      '#FF2F4A',
    ],
  },
  f1_williams: {
    primary: {
      main: "#ffffff",
    },
    barGraph: [
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
    ],
    fill: [
      '#EBFEF6',
      '#FFFAEC',
      '#F0F9FF',
      '#F1FCEF',
      '#FBF4F8',
      '#E9FFFB',
      '#FEFBE8',
      '#FFF3FE',
      '#F4F2FF',
      '#FFF1F3',
    ],
    stroke: [
      '#009E73',
      '#D55E00',
      '#0072B2',
      '#3FD03E',
      '#CC79A7',
      '#00EFEE',
      '#ECA906',
      '#F73EE7',
      '#4A18BF',
      '#FF2F4A',
    ],
  },
  ovative: {
    primary: {
      main: "#ffffff",
    },
    barGraph: [
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
    ],
    fill: [
      '#EBFEF6',
      '#FFFAEC',
      '#F0F9FF',
      '#F1FCEF',
      '#FBF4F8',
      '#E9FFFB',
      '#FEFBE8',
      '#FFF3FE',
      '#F4F2FF',
      '#FFF1F3',
    ],
    stroke: [
      '#009E73',
      '#D55E00',
      '#0072B2',
      '#3FD03E',
      '#CC79A7',
      '#00EFEE',
      '#ECA906',
      '#F73EE7',
      '#4A18BF',
      '#FF2F4A',
    ],
  },
  scottish_widows: {
    primary: {
      main: "#ffffff",
    },
    barGraph: [
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
    ],
    fill: [
      '#EBFEF6',
      '#FFFAEC',
      '#F0F9FF',
      '#F1FCEF',
      '#FBF4F8',
      '#E9FFFB',
      '#FEFBE8',
      '#FFF3FE',
      '#F4F2FF',
      '#FFF1F3',
    ],
    stroke: [
      '#009E73',
      '#D55E00',
      '#0072B2',
      '#3FD03E',
      '#CC79A7',
      '#00EFEE',
      '#ECA906',
      '#F73EE7',
      '#4A18BF',
      '#FF2F4A',
    ],
  },
  salon_Lofts: {
    primary: {
      main: "#ffffff",
    },
    barGraph: [
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
    ],
    fill: [
      '#EBFEF6',
      '#FFFAEC',
      '#F0F9FF',
      '#F1FCEF',
      '#FBF4F8',
      '#E9FFFB',
      '#FEFBE8',
      '#FFF3FE',
      '#F4F2FF',
      '#FFF1F3',
    ],
    stroke: [
      '#009E73',
      '#D55E00',
      '#0072B2',
      '#3FD03E',
      '#CC79A7',
      '#00EFEE',
      '#ECA906',
      '#F73EE7',
      '#4A18BF',
      '#FF2F4A',
    ],
  },
  general: {
    primary: {
      main: "#ffffff",
    },
    barGraph: [
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
      "#1A303F",
    ],
    fill: [
      '#EBFEF6',
      '#FFFAEC',
      '#F0F9FF',
      '#F1FCEF',
      '#FBF4F8',
      '#E9FFFB',
      '#FEFBE8',
      '#FFF3FE',
      '#F4F2FF',
      '#FFF1F3',
    ],
    stroke: [
      '#009E73',
      '#D55E00',
      '#0072B2',
      '#3FD03E',
      '#CC79A7',
      '#00EFEE',
      '#ECA906',
      '#F73EE7',
      '#4A18BF',
      '#FF2F4A',
    ],
  },
};
